import { type Enum } from '@webapp/infrastructure/types/Enum'

export const ExpenseApprovalActions = {
  REQUEST: 0,
  FINAL_APPROVE: 1,
  DENY: 2,
  APPROVE_AND_PASS: 3,
  RESUBMIT: 7,
} as const

export type ExpenseApprovalActionEnum = Enum<typeof ExpenseApprovalActions>
